import type { IconSvgObject } from './types';

const BookmarkRemove02Icon: IconSvgObject = [
  ["path", { d: "M20.5 2.5L14.5 8.5M14.5 2.5L20.5 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 2.5H5.5C4.39543 2.5 3.5 3.39543 3.5 4.5V21.5L11 17.5L18.5 21.5V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookmarkRemove02Icon;
